import {ClientEvent} from '@udemy/event-tracking';

import {NOTICE_TYPE} from '../constants';

export interface NoticeEventDetails {
    noticeId: number;
    noticeType: string | NOTICE_TYPE;
    personalizedNoticeSetId?: number | null;
    personalizedNoticeSetName?: string | null;
    topMembershipTargetGroupId?: number | null;
}

export interface BannerEventDetails extends NoticeEventDetails {
    slideNumber: number | null;
    url: string | null;
    uiRegion: string | null;
    pageKey: string | null;
}

export class BannerImpressionEvent extends ClientEvent {
    private noticeId: NoticeEventDetails['noticeId'];
    private noticeType: NoticeEventDetails['noticeType'];
    private personalizedNoticeSetId: NoticeEventDetails['personalizedNoticeSetId'];
    private personalizedNoticeSetName: NoticeEventDetails['personalizedNoticeSetName'];
    private topMembershipTargetGroupId: NoticeEventDetails['topMembershipTargetGroupId'];
    private slideNumber: number | null;
    private pageKey: string | null;
    constructor({
        noticeId = 0,
        noticeType,
        personalizedNoticeSetId = null,
        personalizedNoticeSetName = null,
        topMembershipTargetGroupId = null,
        slideNumber = null,
        pageKey = null,
    }: BannerEventDetails) {
        super('BannerImpressionEvent');
        this.noticeId = noticeId;
        this.noticeType = noticeType;
        this.personalizedNoticeSetId = personalizedNoticeSetId;
        this.personalizedNoticeSetName = personalizedNoticeSetName;
        this.topMembershipTargetGroupId = topMembershipTargetGroupId;
        this.slideNumber = slideNumber;
        this.pageKey = pageKey;
    }
}

export class BannerClickEvent extends ClientEvent {
    private noticeId: NoticeEventDetails['noticeId'];
    private noticeType: NoticeEventDetails['noticeType'];
    private personalizedNoticeSetId: NoticeEventDetails['personalizedNoticeSetId'];
    private personalizedNoticeSetName: NoticeEventDetails['personalizedNoticeSetName'];
    private topMembershipTargetGroupId: NoticeEventDetails['topMembershipTargetGroupId'];
    private slideNumber: number | null;
    private url: string | null;
    private uiRegion: string | null;
    private pageKey: string | null;
    constructor({
        noticeId = 0,
        noticeType,
        personalizedNoticeSetId = null,
        personalizedNoticeSetName = null,
        topMembershipTargetGroupId = null,
        slideNumber = null,
        url = null,
        uiRegion = null,
        pageKey = null,
    }: BannerEventDetails) {
        super('BannerClickEvent');
        this.noticeId = noticeId;
        this.noticeType = noticeType;
        this.personalizedNoticeSetId = personalizedNoticeSetId;
        this.personalizedNoticeSetName = personalizedNoticeSetName;
        this.topMembershipTargetGroupId = topMembershipTargetGroupId;
        this.slideNumber = slideNumber;
        this.url = url;
        this.uiRegion = uiRegion;
        this.pageKey = pageKey;
    }
}
